<template>
  <div class="plan">
    <div class="top">
      <BaseSkeletonLine class="title-skeleton" />
      <BaseSkeletonLine class="price-skeleton" />
    </div>
    <BaseSkeletonLine class="feature-skeleton" />
    <BaseSkeletonLine class="feature-skeleton short" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import BaseSkeletonLine from "@/components/base/BaseSkeletonLine.vue";

export default defineComponent({
  components: {
    BaseSkeletonLine,
  },
});
</script>
<style lang="scss" scoped>
.plan {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border-radius: $border-radius-m;
  @include themed() {
    border: 1px solid t($grey-15);
    background-color: t($bg);
  }
}

.top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.title-skeleton {
  width: 120px;
}

.price-skeleton {
  width: 64px;
}

.feature-skeleton {
  width: 70%;

  &.short {
    width: 50%;
  }
}
</style>
